import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Manifesto } from "../components/Manifesto";
import { MarqueeStrip } from "../components/Marquee";
import { Services } from "../components/Services";
import { About } from "../components/About";
import { Booking } from "../components/Booking";
import { Footer } from "../components/Footer";

export default function Landing() {
  return (
    <div className="relative bg-background text-foreground">
      <div className="grain-overlay" />
      <Header />
      <main>
        <Hero />
        <Manifesto />
        <MarqueeStrip />
        <Services />
        <About />
        <Booking />
      </main>
      <Footer />
    </div>
  );
}
